<div *ngIf="guid == 'a9dbd402-c5fe-4aaa-93f8-ed718834d8fc' ">
  <app-cadastro-lawservices></app-cadastro-lawservices>
</div>
<div *ngIf="guid == '9f5f628b-6d4b-42d0-b3bb-8c5417e8d64d' ">
  <app-cadastro-imed></app-cadastro-imed>
</div>
